import React from 'react';
import css from './GeneralContractors.module.css';
import Slider from 'react-slick';
import first from '../../../../../assets/images/1.png';
import second from '../../../../../assets/images/2.png';
import third from '../../../../../assets/images/3.png';
import fourth from '../../../../../assets/images/4.png';
import fifth from '../../../../../assets/images/5.png';
import sixth from '../../../../../assets/images/6.png';


const brandImage = [
    {
        brandIcon: first,
    },
    {
        brandIcon: second,
    },
    {
        brandIcon: third,
    },
    {
        brandIcon: fourth,
    },
    {
        brandIcon: fifth,
    },
    {
        brandIcon: sixth,
    },
]

function GeneralContractors() {
    let settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        // autoplay:true,
        // autoplaySpeed:1500,

        // initialSlide: 0,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 1260,
                settings: {
                  slidesToShow: 3.5,
                  slidesToScroll: 1,
                }
              },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 460,
              settings: {
                slidesToShow: 2.2,
                slidesToScroll: 1
              }
            }
          ]
    };
    return (
        <div className={css.contractorWrapper}>
            <div className={css.leftBox}>
                <div className={css.headingName}>
                    <div className={css.smallText}>Our</div>
                    <div className={css.largeText}>General</div>
                    <div className={css.largeText}>Contractors</div>
                </div>
            </div>
            <div className={css.rightSlider}>
                <Slider {...settings}>
                    {brandImage.map((item, i) => {
                        return (
                            <div className={css.brandBox}>
                                <img src={item.brandIcon} />
                            </div>
                        )
                    })}
                </Slider>
            </div>
        </div>
    )
}

export default GeneralContractors